export const defaultKeyValueGetter = (item: any) => item.id as string | number;
export const defaultDisplayValueGetter =  (item: any) => item.name as string;
